import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

import { Sidebar } from '../../../../core/services/sidebar';
import { countries } from '../../../../shared/utils/data';
import { CustomDropdown } from "../../../../shared/components/custom-dropdown/custom-dropdown";
import { InputField } from "../../../../shared/ui/input-field/input-field";
import { Button } from "../../../../shared/ui/button/button";

@Component({
  selector: 'app-step2-business-address',
  imports: [CommonModule, ReactiveFormsModule, CustomDropdown, InputField, TranslatePipe, Button],
  templateUrl: './step2-business-address.html',
  styleUrl: './step2-business-address.css'
})
export class Step2BusinessAddress {
  @Input() data: any;
  @Input() onboardingStep!: number;
  @Input() onboardingSubStep!: number;
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();

  countriesOptions = countries;

  businessAddressForm = new FormGroup({
    country: new FormControl('', [Validators.required]),
    city: new FormControl('', [Validators.required]),
    district: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(50),
      Validators.pattern(/^[A-Za-z ]+$/)
    ]),

    area: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
      Validators.pattern(/^[A-Za-z0-9 ]+$/)
    ]),

    streetName: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
      Validators.pattern(/^[A-Za-z0-9 .,-]+$/)
    ]),

    buildingNumber: new FormControl('', [
      Validators.maxLength(10),
      Validators.pattern(/^[A-Za-z0-9]+$/)
    ]),

    officeNumber: new FormControl('', [
      Validators.maxLength(10),
      Validators.pattern(/^[A-Za-z0-9]+$/)
    ]),

    nearestLandmark: new FormControl('', [
      Validators.maxLength(100),
      Validators.pattern(/^[A-Za-z0-9 ]+$/)
    ]),

    poBoxNumber: new FormControl('', [Validators.required, Validators.pattern(/^[0-9]+$/),
    Validators.maxLength(10)]),

    corporatePhone: new FormControl('', [
      Validators.required,
      Validators.pattern(/^79\d{8}$/),
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.email,
    ]),
    website: new FormControl('', [
      Validators.required, Validators.pattern(/^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*\/?$/)
    ]),
  });

  constructor(private sidebarService: Sidebar) { }

  ngOnInit(): void {
    this.sidebarService.setLinks([
      { label: 'SIDEBAR.PREVIOUS_SCREEN', action: () => this.goBackStep(), iconPath: 'assets/icons/arrow-blue.svg', variant: 'outlined' },
      { label: 'SIDEBAR.SAVE_EXIT', route: '/', iconPath: 'assets/icons/cancel-blue.svg', variant: 'plain' }
    ]);
  }

  onDropdownSelect(controlName: string, selectedItem: any) {
    this.businessAddressForm.get(controlName)?.setValue(selectedItem);
  }

  handleFormSubmission() {
    // console.log('Form submitted!', this.businessAddressForm.value);
    this.next.emit();
  }

  getControl(controlName: string): FormControl {
    return this.businessAddressForm.get(controlName) as FormControl;
  }

  goBackStep() {
    this.prev.emit();
  }
}
